export const formFieldsData = {

    planName: {
        key: 'planName',
        type: 'text',
        label: 'Plan Name',
        placeholder: 'Must be Unique',
        required: true,
        requiredMessage: 'This field is required.',
        minLength: 3,
        minLengthMessage: 'Minimum 3 character allowed.',
        maxLength: 100,
        maxLengthMessage: 'Maximum 100 character allowed.',
        displayLayout: 'col-md-12',
        tooltip: '<div>  Plan Name </div>',
        labelLayout: 'col-sm-12',
        // pattern: /^(?=.*?[A-Za-z]).{1,}$/,
        spaceNotAllowed: true,

    },

    planDisplayName: {
        key: 'planDisplayName',
        type: 'text',
        label: 'Plan Display Name',
        placeholder: 'Multilingual Support, Length Max 15 Char',
        required: true,
        requiredMessage: 'This field is required.',
        minLength: 3,
        minLengthMessage: 'Minimum 3 character allowed.',
        maxLength: 15,
        maxLengthMessage: 'Maximum 15 character allowed.',
        displayLayout: 'col-md-12',
        tooltip: '<div> Plan Display Name </div>',
        labelLayout: 'col-sm-12',
        // pattern: /^(?=.*?[A-Za-z]).{1,}$/,
        // maxLength: 80,
        // maxLengthMessage: 'maximum 80 characters allowed.',
        spaceNotAllowed: true,

    },

    startDate: {
        key: 'startDate',
        label: 'Start Date',
        required: true,
        placeholder: 'DD/MM/YYYY',
        displayLayout: 'col-sm-12',
        requiredMessage: 'This field is required.',
        labelLayout: 'col-sm-12',
    },
    endDate: {
        key: 'endDate',
        label: 'End Date',
        required: false,
        placeholder: 'DD/MM/YYYY',
        addBreakOption: true,
        displayLayout: 'col-sm-12',
        labelLayout: 'col-sm-12',
        requiredMessage: 'This field is required.',
    },

    planType: {
        key: 'planType',
        label: 'Plan Type',
        placeholder: 'Select One',
        displayLayout: 'col-sm-12',
        required: true,
        requiredMessage: 'This field is required.',
        labelLayout: 'col-sm-12',
        valueKey: 'id',
        textKey: 'value',
    },

    amountCharges: {
        key: 'amountCharges',
        type: 'number',
        label: 'Amount / Charges',
        placeholder: '',
        required: true,
        requiredMessage: 'This field is required.',
        labelLayout: 'col-sm-12',
        // min: 1,
        // max: 99,
        // upto4Digit: true,
        displayLayout: 'col-md-12',
        tooltip: '<div> Target Value </div>',
        // pattern: /^\d+(\.\d{1,2})?$/
    },

    tenantSupported: {
        key: 'tenantSupported',
        label: 'Tenant Supported',
        placeholder: 'Select One',
        displayLayout: 'col-sm-12',
        required: true,
        requiredMessage: 'This field is required.',
        labelLayout: 'col-sm-12',
        addBreakOptional: false,
        valueKey: 'id',
        textKey: 'value',
    },

    offer: {
        key: 'offer',
        label: 'Offer',
        placeholder: '--Select--',
        displayLayout: 'col-sm-12',
        required: true,
        requiredMessage: 'This field is required.',
        valueKey: 'id',
        textKey: 'value',
        labelLayout: 'col-sm-12',
    },

    offerValue: {
        key: 'offerValue',
        type: 'number',
        label: 'Offer Value',
        placeholder: '',
        required: true,
        requiredMessage: 'This field is required.',
        addBreakOptional: false,
        labelLayout: 'col-sm-12',
        // min: 1,
        // max: 100,
        // minLengthMessage: 'Minimum 1 characters allowed.',
        // maxLengthMessage: 'Maximum 100 characters allowed.',
        displayLayout: 'col-md-12',

    },

    countrySupported: {
        key: 'countrySupported',
        label: 'Country Supported',
        placeholder: '--Select--',
        displayLayout: 'col-sm-12',
        required: true,
        requiredMessage: 'This field is required.',
        labelLayout: 'col-sm-12',
        valueKey: 'id',
        textKey: 'value',
    },

    outage: {
        key: 'outage',
        type: 'number',
        label: 'Outage %',
        placeholder: 'Values between 0.1 to 99',
        required: true,
        requiredMessage: 'This field is required.',
        min: 0.1,
        max: 99,
        minLengthMessage: 'Maximum 0.1 characters allowed.',
        maxLengthMessage: 'Maximum 99 characters allowed.',
        displayLayout: 'col-md-12',
        labelLayout: 'col-sm-12',

    },

    currencySupported: {
        key: 'currencySupported',
        label: 'Currency Supported',
        placeholder: 'Select One',
        displayLayout: 'col-sm-12',
        required: true,
        requiredMessage: 'This field is required.',
        valueKey: 'id',
        textKey: 'value',
        labelLayout: 'col-sm-12',
    },

    spendLimit: {
        key: 'spendLimit',
        label: 'Spend Limit',
        placeholder: '--Select--',
        displayLayout: 'col-sm-12',
        required: true,
        requiredMessage: 'This field is required.',
        valueKey: 'id',
        textKey: 'value',
        labelLayout: 'col-sm-12',
    },

    spendLimitValue: {
        key: 'spendLimitValue',
        type: 'number',
        label: 'Spend Limit Value',
        placeholder: '',
        required: true,
        requiredMessage: 'This field is required.',
        addBreakOptional: false,
        labelLayout: 'col-sm-12',
        // min: 1,
        // max: 99,
        // upto4Digit: true,
        displayLayout: 'col-md-12',

    },

    autoRenew: {
        key: 'autoRenew',
        label: 'Auto Renew',
        placeholder: 'Select One',
        displayLayout: 'col-sm-12',
        required: true,
        requiredMessage: 'This field is required.',
        valueKey: 'id',
        textKey: 'value',
        labelLayout: 'col-sm-12',
      },

      duration: {
        key: 'duration',
        label: 'Duration',
        placeholder: 'Select One',
        displayLayout: 'col-sm-12',
        required: true,
        requiredMessage: 'This field is required.',
        valueKey: 'id',
        textKey: 'value',
        addBreakOptional: false,
        labelLayout: 'col-sm-12',
    },

    durationLimit: {
        key: 'durationLimit',
        type: 'number',
        label: 'Duration Limit Value',
        placeholder: 'values in numbers',
        required: true,
        requiredMessage: 'This field is required.',
        addBreakOptional: false,
        labelLayout: 'col-sm-12',
        // min: 1,
        // max: 99,
        // upto4Digit: true,
        displayLayout: 'col-md-12',

    },
    reNewPlan: {
        key: 'reNewPlan',
        label: 'Renew Plan',
        placeholder: '--Select--',
        displayLayout: 'col-sm-12',
        required: true,
        requiredMessage: 'This field is required.',
        addBreakOptional: false,
        labelLayout: 'col-sm-12',
        valueKey: 'id',
        textKey: 'value',
      },
      displaySupported: {
        key: 'displaySupported',
        label: 'Display Supported',
        placeholder: 'Select One',
        displayLayout: 'col-sm-12',
        required: true,
        requiredMessage: 'This field is required.',
        labelLayout: 'col-sm-12',
        valueKey: 'id',
        textKey: 'value',
      },

      status: {
        key: 'status',
        label: 'Status',
        placeholder: '--Select--',
        displayLayout: 'col-sm-12',
        required: true,
        requiredMessage: 'This field is required.',
        valueKey: 'id',
        textKey: 'value',
        labelLayout: 'col-sm-12',
      },
}

export const planStatusOptions = [
  { id: '2', value: 'Draft' },
  { id: '1', value: 'Active' },
  { id: '0', value: 'Inactive' },
]

export const planTypeOptions = [
  { id: '1', value: 'Standard' },
  { id: '2', value: 'Custom' },
]

export const offerOptions =[
  { id: '0', value: 'NA' },
  { id: '1', value: 'IN %' },
  { id: '2', value: 'Fix' },
]

export const autoRenewOptions =[
  { id: '1', value: 'Yes' },
  { id: '0', value: 'No' },
]
export const displaySupportedOptions =[
  { id: '1', value: 'Yes' },
  { id: '0', value: 'No' },
]

// get from config
export const durationOptions =[
  { id: '30', value: '30' },
  { id: '90', value: '90' },
]


export const spendLimitOptions =[
  { id: '0', value: 'Limited' },
  { id: '1', value: 'Unlimited' },
  ]